export const LEAP_RED = '#af0000'
export const LEAP_RED_RGB = '175, 0, 0'
export const LEAP_RED_DARK = '#8B0000'

/** Dashboard / overview app — pairs with RFID Operations. */
export const APP_NAME = 'RFID Control Tower'
export const APP_SUBTITLE = 'Live visibility'
export const APP_TAGLINE = 'See every tag. Command every move.'

export function leapRedRgba(alpha: number): string {
  return `rgba(${LEAP_RED_RGB}, ${alpha})`
}
